// GENERATED FILE, PLEASE DO NOT EDIT
import { FontFamilies, LetterSpacings, LineHeights, Sizes, TextTransforms } from '../constants';
export var Bold40 = {
  size: Sizes.S40,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: LetterSpacings.Tight,
  lineHeight: LineHeights.S40,
  textTransform: TextTransforms.Normal
};
export var Bold32 = {
  size: Sizes.S32,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: LetterSpacings.Tight,
  lineHeight: LineHeights.S32,
  textTransform: TextTransforms.Normal
};
export var Bold24 = {
  size: Sizes.S24,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: LetterSpacings.Tight,
  lineHeight: LineHeights.S24,
  textTransform: TextTransforms.Normal
};
export var Bold18 = {
  size: Sizes.S18,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: LetterSpacings.Tight,
  lineHeight: LineHeights.S18,
  textTransform: TextTransforms.Normal
};
export var Bold16 = {
  size: Sizes.S16,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: LetterSpacings.Tight,
  lineHeight: LineHeights.S16,
  textTransform: TextTransforms.Normal
};
export var Bold14 = {
  size: Sizes.S14,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: LetterSpacings.Tight,
  lineHeight: LineHeights.S14,
  textTransform: TextTransforms.Normal
};
export var Bold12 = {
  size: Sizes.S12,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'Bold',
  letterSpacing: LetterSpacings.Tight,
  lineHeight: LineHeights.S12,
  textTransform: TextTransforms.Normal
};
export var Medium24 = {
  size: Sizes.S24,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'Medium',
  letterSpacing: LetterSpacings.Normal,
  lineHeight: LineHeights.S24,
  textTransform: TextTransforms.Normal
};
export var Medium18 = {
  size: Sizes.S18,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'Medium',
  letterSpacing: LetterSpacings.Normal,
  lineHeight: LineHeights.S18,
  textTransform: TextTransforms.Normal
};
export var Medium16 = {
  size: Sizes.S16,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'Medium',
  letterSpacing: LetterSpacings.Normal,
  lineHeight: LineHeights.S16,
  textTransform: TextTransforms.Normal
};
export var Medium14 = {
  size: Sizes.S14,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'Medium',
  letterSpacing: LetterSpacings.Normal,
  lineHeight: LineHeights.S14,
  textTransform: TextTransforms.Normal
};
export var Medium12 = {
  size: Sizes.S12,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'Medium',
  letterSpacing: LetterSpacings.Normal,
  lineHeight: LineHeights.S12,
  textTransform: TextTransforms.Normal
};
export var Caps18 = {
  size: Sizes.S18,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'ExtraBold',
  letterSpacing: LetterSpacings.Wide,
  lineHeight: LineHeights.S18,
  textTransform: TextTransforms.UpperCase
};
export var Caps16 = {
  size: Sizes.S16,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'ExtraBold',
  letterSpacing: LetterSpacings.Wide,
  lineHeight: LineHeights.S16,
  textTransform: TextTransforms.UpperCase
};
export var Caps14 = {
  size: Sizes.S14,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'ExtraBold',
  letterSpacing: LetterSpacings.Wide,
  lineHeight: LineHeights.S14,
  textTransform: TextTransforms.UpperCase
};
export var Caps12 = {
  size: Sizes.S12,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'ExtraBold',
  letterSpacing: LetterSpacings.Wide,
  lineHeight: LineHeights.S12,
  textTransform: TextTransforms.UpperCase
};
export var Caps10 = {
  size: Sizes.S10,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'ExtraBold',
  letterSpacing: LetterSpacings.Wide,
  lineHeight: LineHeights.S10,
  textTransform: TextTransforms.UpperCase
};
export var Regular18 = {
  size: Sizes.S18,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'Regular',
  letterSpacing: LetterSpacings.Normal,
  lineHeight: LineHeights.S18,
  textTransform: TextTransforms.Normal
};
export var Regular16 = {
  size: Sizes.S16,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'Regular',
  letterSpacing: LetterSpacings.Normal,
  lineHeight: LineHeights.S16,
  textTransform: TextTransforms.Normal
};
export var Regular14 = {
  size: Sizes.S14,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'Regular',
  letterSpacing: LetterSpacings.Normal,
  lineHeight: LineHeights.S14,
  textTransform: TextTransforms.Normal
};
export var Regular12 = {
  size: Sizes.S12,
  family: FontFamilies.SansSerif,
  color: 'TextPrimary',
  weight: 'Regular',
  letterSpacing: LetterSpacings.Normal,
  lineHeight: LineHeights.S12,
  textTransform: TextTransforms.Normal
};